import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { handelNotifications } from '../../../../redux/slices/Notification/notificationSlice'
import { routes } from '../../../../utils/constants'
import useAxios from '../../../../hooks/useAxios'
import DealForm from '../../classes/DealForm'
import useDealSetting from '../../hook/deal.setting'
import { checkSomeLoader } from '../../../../helper'
import { Box } from '@mui/material'
import { Label } from '../../../../components/styled/global.style'
import {
  AutocompleteStyle,
  DealBodyContainer,
  DealBodySubContainer,
  TextFieldModalStyle,
  UnVisibleSubmitButton
} from '../../../Deal/Deal.style'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import SpotDeal from '../SpotDeal/SpotDeal'
import NdfDeal from '../NdfDeal/NdfDeal'
import SwapDealClientSide from '../SwapDealClientSide/SwapDealClientSide'
import SwapDealMarketMakerSide from '../SwapDealMarketMakerSide/SwapDealMarketMakerSide'
import VanillaDealClientSide from '../VanillaDealClientSide/VanillaDealClientSide'
import VanillaDealMarketMakerSide from '../VanillaDealMarketMakerSide/VanillaDealMarketMakerSide'
import Loader from '../../../../components/Loader/Loader'
import ModalBottomVanillaDeal from '../../../../components/ModalApp/components/ModalBottom/ModalBottomVanillaDeal/ModalBottomVanillaDeal'
import ModalBottom from '../../../../components/ModalApp/components/ModalBottom/ModalBottom'
import { webSocketWorkerEvent } from '../../../../services'

const Body = ({ data }) => {
  const { method } = data
  const [page, setPage] = useState(false)
  const [errors, setErrors] = useState({})
  const dispatch = useDispatch()
  let loaderFirstTime = useRef(true).current

  useEffect(() => {
    const handelMessage = message => {
      if (message.data.type === 'create_deal' && message.data.status === 'ok') {
        dispatch(
          handelNotifications({
            id: Date.now(),
            type: 'success',
            message: 'Deal Made Successfully'
          })
        )
      }
    }

    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [dispatch])

  const dealTypeInitial = { id: 0, name: '', deal_type_group: '' }
  const currencyInitial = { id: 0, name: '', code3: '', is_ndf: '' }

  const request1 = {
    endPoint: routes.currency
  }
  const request2 = {
    endPoint: routes.side
  }
  const request3 = {
    endPoint: routes.counterParty,
    params: {
      direction: 'Client',
      is_active: 1
    }
  }

  const request4 = {
    endPoint: routes.counterParty,
    params: {
      direction: 'Market Maker',
      is_active: 1
    }
  }

  const request5 = {
    endPoint: routes.dealTypes
  }

  const request6 = {
    endPoint: routes.cut
  }

  const request7 = {
    endPoint: routes.fixingSource
  }

  const request8 = {
    endPoint: routes.trader
  }

  const request9 = {
    endPoint: routes.currencyNormalize
  }

  const request10 = {
    endPoint: routes.tradingAccountTradersNormalize
  }

  const request11 = {
    endPoint: routes.tradingAccountPrimeBrokerNormalize
  }

  const { response: currencyData, loading: currencyLoader } = useAxios(request1)
  const { response: sides, loading: sidesLoader } = useAxios(request2)
  const { response: counterpartiesOrderClient, loading: counterpartiesOrderClientLoader } =
    useAxios(request3)
  const { response: counterpartiesOrderMarket, loading: counterpartiesOrderMarketFirstLoader } =
    useAxios(request4)
  const { response: dealTypes, loading: dealTypesLoader } = useAxios(request5)
  const { response: cut, loading: cutLoader } = useAxios(request6)
  const { response: fixingSource, loading: fixingSourceLoader } = useAxios(request7)
  const { response: traders, loading: tradersLoader } = useAxios(request8)
  const { response: currencyNormalize, loading: currencyNormalizeLoader } = useAxios(request9)
  const {
    response: tradingAccountTradersNormalize,
    loading: tradingAccountTradersNormalizeLoader
  } = useAxios(request10)
  const {
    response: tradingAccountPrimeBrokerNormalize,
    loading: tradingAccountPrimeBrokerNormalizeLoader
  } = useAxios(request11)

  const loaderList = [
    currencyLoader,
    sidesLoader,
    counterpartiesOrderClientLoader,
    counterpartiesOrderMarketFirstLoader,
    dealTypesLoader,
    cutLoader,
    fixingSourceLoader,
    tradersLoader,
    currencyNormalizeLoader,
    tradingAccountTradersNormalizeLoader,
    tradingAccountPrimeBrokerNormalizeLoader
  ]

  const [form, setForm] = useState(new DealForm())

  const {
    getContinueButtonTitle,
    disabled,
    submitForm,
    handelDateChange,
    handelFormChange,
    disabledField,
    exoticDealBody,
    handelBackButtonVanillaDeal,
    handelFocusCurrencyPair,
    handelBlurCurrencyPair,
    getTradeTemplateGridRow,
    checkPrimeBrokerIsRBS,
    swapOption
  } = useDealSetting({
    currencyData,
    currencyInitial,
    currencyNormalize,
    page,
    setPage,
    form,
    setForm,
    tradingAccountPrimeBrokerNormalize,
    errors,
    setErrors
  })

  const handelSubmit = event => {
    event.preventDefault()
    if (!disabled()) {
      submitForm()
    }
  }

  if (checkSomeLoader(loaderList) && loaderFirstTime) {
    loaderFirstTime = false
    return <Loader />
  }

  const exoticDeal = exoticDealBody()

  return (
    <DealBodyContainer>
      <DealBodySubContainer
        component={'form'}
        container
        style={getTradeTemplateGridRow()}
        onSubmit={handelSubmit}
      >
        <Box width={'100%'}>
          <Label>Deal Type *</Label>
          {Array.isArray(dealTypes.data) && (
            <AutocompleteStyle
              onChange={(event, element) => {
                event.target.name = 'deal_type'
                element = element ?? dealTypeInitial
                handelFormChange(event, element)
              }}
              size={'small'}
              disabled={page}
              value={form.trade_type}
              getOptionLabel={option => option.name}
              options={dealTypes.data}
              renderInput={params => (
                <TextFieldModalStyle
                  {...params}
                  fullWidth
                  autoFocus
                  placeholder="Select Deal"
                  disabled={page}
                />
              )}
              ListboxComponent={PaperAutoComplete}
            />
          )}
        </Box>
        {['', 'Spot', 'Forward'].includes(form.deal_type.deal_type_group) && (
          <SpotDeal
            form={form}
            errors={errors}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            handelFormChange={handelFormChange}
            handelDateChange={handelDateChange}
            clients={counterpartiesOrderClient}
            marketMakers={counterpartiesOrderMarket}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
            sides={sides}
          />
        )}

        {['Swap'].includes(form.deal_type.deal_type_group) && page === false && (
          <SwapDealClientSide
            form={form}
            sides={sides}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            swapOption={swapOption}
            errors={errors}
            fixingSource={fixingSource}
            clients={counterpartiesOrderClient}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
          />
        )}
        {['Swap'].includes(form.deal_type.deal_type_group) && page === true && (
          <SwapDealMarketMakerSide
            form={form}
            sides={sides}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
            handelDateChange={handelDateChange}
            handelFormChange={handelFormChange}
            swapOption={swapOption}
            errors={errors}
            fixingSource={fixingSource}
            marketMakers={counterpartiesOrderMarket}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
          />
        )}
        {['NDF'].includes(form.deal_type.deal_type_group) && (
          <NdfDeal
            clients={counterpartiesOrderClient}
            marketMakers={counterpartiesOrderMarket}
            sides={sides}
            fixingSource={fixingSource}
            handelFormChange={handelFormChange}
            form={form}
            handelFocusCurrencyPair={handelFocusCurrencyPair}
            handelBlurCurrencyPair={handelBlurCurrencyPair}
            errors={errors}
            handelDateChange={handelDateChange}
            checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
          />
        )}
        {!['', 'Spot', 'Swap', 'Forward', 'NDF'].includes(form.deal_type.deal_type_group) &&
          page === false && (
            <VanillaDealClientSide
              clients={counterpartiesOrderClient}
              fixingSource={fixingSource}
              putCall={[{ name: 'PUT' }, { name: 'CALL' }]}
              sides={sides}
              cut={cut}
              tradingAccountTradersNormalize={tradingAccountTradersNormalize}
              currencyInitial={currencyInitial}
              form={form}
              errors={errors}
              traders={traders}
              disabledField={disabledField()}
              handelFocusCurrencyPair={handelFocusCurrencyPair}
              handelBlurCurrencyPair={handelBlurCurrencyPair}
              handelDateChange={handelDateChange}
              handelFormChange={handelFormChange}
              currencyData={currencyData}
              checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
            >
              {exoticDeal && <React.Fragment>{exoticDeal}</React.Fragment>}
            </VanillaDealClientSide>
          )}

        {!['', 'Spot', 'Swap', 'Forward', 'NDF'].includes(form.deal_type.deal_type_group) &&
          page === true && (
            <VanillaDealMarketMakerSide
              marketMakers={counterpartiesOrderMarket}
              fixingSource={fixingSource}
              putCall={[{ name: 'PUT' }, { name: 'CALL' }]}
              sides={sides}
              cut={cut}
              tradingAccountTradersNormalize={tradingAccountTradersNormalize}
              form={form}
              traders={traders}
              errors={errors}
              disabledField={disabledField()}
              handelFocusCurrencyPair={handelFocusCurrencyPair}
              handelBlurCurrencyPair={handelBlurCurrencyPair}
              handelDateChange={handelDateChange}
              handelFormChange={handelFormChange}
              currencyData={currencyData}
              currencyInitial={currencyInitial}
              checkPrimeBrokerIsRBS={checkPrimeBrokerIsRBS()}
            >
              {exoticDeal && <React.Fragment>{exoticDeal}</React.Fragment>}
            </VanillaDealMarketMakerSide>
          )}

        <UnVisibleSubmitButton type="submit" onSubmit={handelSubmit}></UnVisibleSubmitButton>
      </DealBodySubContainer>

      <Box>
        {page === false && (
          <ModalBottom
            method={method}
            title={getContinueButtonTitle()}
            submitForm={submitForm}
            disabled={disabled()}
            justifyContent="space-between"
            padding={{ paddingLeft: '0px', paddingRight: '0px' }}
          />
        )}
        {!['', 'Spot', 'Forward', 'NDF'].includes(form.deal_type.deal_type_group) &&
          page === true && (
            <ModalBottomVanillaDeal
              method={method}
              title={getContinueButtonTitle()}
              submitForm={submitForm}
              disabled={disabled()}
              handelClick={handelBackButtonVanillaDeal}
              justifyContent="space-between"
            />
          )}
      </Box>
    </DealBodyContainer>
  )
}

export default Body

Body.propTypes = {
  data: PropTypes.object,
  method: PropTypes.string
}
